import Luff, { React } from "luff";
import WebApi from "api";

import "luff/index.css";
import "luff-comp/index.css";
//import "luff-comp/img/no-image.svg";

import './Auth.scss';
import LocaleControl from "../_common/Components/LocaleControl/LocaleControl";
import {ButtonBusy, CheckBox, TextBox} from "luff-comp";
import {L10n} from "../_common/L10n/L10n";
import AppLocalStore from "../_context/LocalStorage";
import {TwoFactorMan} from "../_common/Components/_Blocks/TwoFactorMan/TwoFactorMan";

window['Luff'] = Luff;
window['api'] = WebApi;
WebApi.debug = true;
WebApi.onUnauth = null;

Luff.Application.Settings.Route.IsShowEmptyRouteLink = true;

let defaultLogin = '';
let defaultPwd = '';
// // #!if ENV === 'development'
// defaultLogin = 'admin';
// defaultPwd = 'pass2root';
// // #!endif

if (import.meta.env.MODE == "development") {
    defaultLogin = 'sa';
    defaultPwd = 'pass2root';
}

class Auth extends Luff.Content {
    private Login = Luff.State(defaultLogin);
    private Pwd = Luff.State(defaultPwd);

    private IsRememberMe = Luff.State(false);
    private IsPasswordVisible = Luff.State(false);
    private IsLoginFormVisible = Luff.State(true);

    private ButtonLogin: ButtonBusy;
    private TwoFactor: TwoFactorMan;

    protected AfterBuild(): void {
        this.ButtonLogin = this.GetComponentByName('btnLogin');
        this.TwoFactor = this.GetComponentByName('TwoFactorMan');
    }

    private ClearAuthTokens() {
        localStorage.removeItem("token");
        localStorage.removeItem("token_refresh");
        localStorage.removeItem("token_expires_in");
    }

    private IsExternalRedirect(url: string): boolean {
        if (!url || (url.startsWith("/") && !url.startsWith("//")))
            return false;
        try {
            return new URL(url, window.location.href).origin !== window.location.origin;
        } catch {
            return false;
        }
    }

    private RedirectAfterLogin(pack: WebApi.AuthPack) {
        WebApi.setTokens(pack);
        const url = (pack as WebApi.AuthResultPack).RedirectUrl || "/";

        if (!this.IsExternalRedirect(url)) {
            document.location.href = url;
            return;
        }

        const sep = url.includes("?") ? "&" : "?";
        document.location.href = `${url}${sep}auth=${encodeURIComponent(JSON.stringify(pack))}`;
    }

    private OnTwoFactorCancel() {
        this.ClearAuthTokens();
        this.IsLoginFormVisible.SValue = true;
    }

    private OnTwoFactorSuccess(success: boolean, authPack?: WebApi.AuthPack) {
        if (success && authPack) {
            this.RedirectAfterLogin(authPack);
        }
    }

    private ShowTwoFactor(res: WebApi.AuthResultPack) {
        this.IsLoginFormVisible.SValue = false;

        if (!res.TwoFactorType) {
            this.TwoFactor.RunSetup(
                (success, authPack) => this.OnTwoFactorSuccess(success, authPack),
                () => this.OnTwoFactorCancel(),
                true,
            );
            return;
        }

        this.TwoFactor.Run(
            res.TwoFactorType,
            (success, authPack) => this.OnTwoFactorSuccess(success, authPack),
            () => this.OnTwoFactorCancel(),
        );
    }

    private TryLogin() {
        this.Login.SValue = this.Login.SValue.trim();

        const login = this.Login.SValue;
        const pass = this.Pwd.SValue;

        if (login.length == 0 || pass.length == 0) {
            Luff.Pop.Error('Введите логин и пароль', { LogItem: 'Введите логин и пароль' });
            return Promise.reject();
        }
        return WebApi.Login_Authenticate(
            login,
            pass,
            this.IsRememberMe.SValue)
            .then(res => {
                if (res && !res.Error) {
                    if (res.IsTwoEnabled && !res.IsTwoFaPassed) {
                        WebApi.setTokens(res);
                        this.ShowTwoFactor(res);
                        return 1;
                    }

                    this.RedirectAfterLogin(res);
                    return 1;
                }

                throw new Error(res.Error);

            })
            .catch(err => {
                const errText = err.message;
                if (errText == "invalid server key")
                    return Luff.Pop.Error("Неизвестный ключ сервера");
                if (errText == "wrong credentials")
                    return Luff.Pop.Error("Неверный логин или пароль");
                if (errText == "request limit")
                    return Luff.Pop.Error("Превышено число попыток входа. Повторите попытку через несколько минут");
                //else
                Luff.Pop.Error("Неверный логин или пароль", {
                    LogItem: "Неверный логин или пароль",
                });
            })
    }
    Render(): Luff.Node {
        return (
            <>
                <div class="auth-bg">
                    <div class="auth-bg-mesh"/>
                    <div class="auth-bg-noise"/>
                </div>

                <div className='auth-main'>
                    <div className='auth-login'>
                        <div className="auth-logo"/>
                        <div className='auth-card'>
                            <div className='auth-card-header' isVisible={this.IsLoginFormVisible}>
                                <div className='auth-title'>
                                    {L10n.GetTextState("Добро пожаловать")}
                                </div>
                                <div className='auth-subtitle'>
                                    {L10n.GetTextState("Вход для зарегистрированных пользователей")}
                                </div>
                            </div>

                            <div className='auth-form' isVisible={this.IsLoginFormVisible}>
                                <label className='auth-field'>
                                    <span className='auth-field-label'>
                                        {L10n.GetTextState("Логин")}
                                    </span>
                                    <div className='auth-field-wrap'>
                                        <span className='auth-field-icon auth-icon-user'/>
                                        <TextBox
                                            value={this.Login}
                                            placeholder={L10n.GetTextState("Введите логин")}
                                        />
                                    </div>
                                </label>

                                <label className='auth-field'>
                                    <span className='auth-field-label'>
                                        {L10n.GetTextState("Пароль")}
                                    </span>
                                    <div className='auth-field-wrap auth-password-field'>
                                        <span className='auth-field-icon auth-icon-lock'/>
                                        <TextBox
                                            value={this.Pwd}
                                            placeholder={L10n.GetTextState("Введите пароль")}
                                            type={this.IsPasswordVisible.SubState(v => v ? "text" : "password")}
                                            onKeyEnter={() => this.ButtonLogin.Click()}
                                        />
                                        <div
                                            className={this.IsPasswordVisible.SubState(v =>
                                                "auth-password-toggle icon-common l-pointer " + (v ? "icon-visibility-on" : "icon-visibility-off")
                                            )}
                                            onClick={() => this.IsPasswordVisible.SValue = !this.IsPasswordVisible.SValue}
                                        />
                                    </div>
                                </label>

                                <div className='auth-options'>
                                    <CheckBox checked={this.IsRememberMe}>
                                        {L10n.GetTextState("Оставаться в системе")}
                                    </CheckBox>
                                </div>

                                <ButtonBusy
                                    className="btn-auth-login"
                                    compName="btnLogin"
                                    onClick={() => this.TryLogin() }
                                >
                                    {L10n.GetTextState("Войти")}
                                </ButtonBusy>

                                <div className='none' id='error'>
                                    <span>Неправильный логин или пароль</span>
                                </div>
                            </div>

                            <TwoFactorMan compName="TwoFactorMan" />
                        </div>
                    </div>
                </div>

                <div class="auth-footer">
                    <span className='auth-footer-text'>
                        © {new Date().getFullYear()} BTLPult. {L10n.GetTextState("Все права защищены")}.
                    </span>
                </div>
            </>
        );
    }
}

L10n.SwitchLocale(AppLocalStore.Language);
new Auth();
Luff.Application.Run();




